import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e1a2311c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e1a2311c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a2311c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-admin-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1a2311c')) {
      api.createRecord('e1a2311c', component.options)
    } else {
      api.reload('e1a2311c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e1a2311c&scoped=true", function () {
      api.rerender('e1a2311c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/SvgIcon/index.vue"
export default component.exports